const state = {
  // 今日教研
  user: { role: {} },
  isLogin: 0,
  isLoginSelected: 0,
  birthday: '',
  entry: '',
  my: '',
  birthdayList: [],
  entryList: [],
  myList: [],
  birthdayPageNum: 0,
  entryPageNum: 0,
  myPageNum: 0,
  imageSrcList: [],
  imageSrcListCard: [],
  selecte: '',
  birthdayCurrentRule: [],
  festivalCurrentRule: {},
  entryCurrentRule: [],
  currentBottomBtn: 0,
  reqFlag: 0,
  apiid: '',
  aa: 0
};

const mutations = {
  AA(state, aa) {
    state.aa = aa;
  },
  APIID(state, apiid) {
    state.apiid = apiid;
  },
  REQFLAG(state, reqFlag) {
    state.reqFlag = reqFlag;
  },
  CURRENTBOTTOMBTN(state, currentBottomBtn) {
    state.currentBottomBtn = currentBottomBtn;
  },
  BIRTHDAYCCURRENTRULE(state, birthdayCurrentRule) {
    state.birthdayCurrentRule = birthdayCurrentRule;
  },
  FESTIVALCURRENTRULE(state, festivalCurrentRule) {
    state.festivalCurrentRule = festivalCurrentRule;
  },
  ENTRYCURRENTRULE(state, entryCurrentRule) {
    state.entryCurrentRule = entryCurrentRule;
  },
  SELECTE(state, selecte) {
    state.selecte = selecte;
  },
  IMAGESRCLIST(state, imageSrcList) {
    state.imageSrcList = imageSrcList;
  },
  IMAGESRCLISTCARD(state, imageSrcListCard) {
    state.imageSrcListCard = imageSrcListCard;
  },
  MYPAGENUM(state, myPageNum) {
    state.myPageNum = myPageNum;
  },
  BIRTHDAYPAGENUM(state, birthdayPageNum) {
    state.birthdayPageNum = birthdayPageNum;
  },
  ENTRYPAGENUM(state, entryPageNum) {
    state.entryPageNum = entryPageNum;
  },
  MYLIST(state, myList) {
    state.myList = state.myList.concat(myList);
  },
  BIRTHDAYLIST(state, birthdayList) {
    state.birthdayList = state.birthdayList.concat(birthdayList);
  },
  ENTRYLIST(state, entryList) {
    state.entryList = state.entryList.concat(entryList);
  },
  MY(state, my) {
    state.my = my;
  },
  BIRTHDAY(state, birthday) {
    state.birthday = birthday;
  },
  ENTRY(state, entry) {
    state.entry = entry;
  },
  USER(state, user) {
    state.user = user;
  },
  ISLOGIN(state, isLogin) {
    state.isLogin = isLogin;
  },
  ISLOGINSELECTED(state, isLoginSelected) {
    state.isLoginSelected = isLoginSelected;
  },
};

const actions = {
};

const getters = {};
export default {
  state,
  mutations,
  actions,
  getters,
};
